
import React, { useState } from "react";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import DateRangeFilter from "components/DateRangeFilter/DateRangeFilter";
import SoftDrinkDp from "./softDrinkdp";
import { getCurrentDate, getFirstDayOfMonth } from "../../Utils/dateUtils";
import { useDateFilter } from "Hooks/useDateFilter.js";
import { SCREEN_KEYS } from "constants/screenKeys.js";


function StoreReport() {

  const { fromDate, toDate, setFromDate, setToDate } = useDateFilter(
       SCREEN_KEYS.STORE_REPORT,
       { fromDate: getFirstDayOfMonth(), toDate: getCurrentDate() }
     );
   
     const handleFromDateChange = (value) => {
      setFromDate(value);
      if (value > toDate) setToDate(value);
    };
  
    const handleToDateChange = (value) => {
      if (value < fromDate) return;
      setToDate(value);
    };


  return (
    <Box minH="100vh" bg="gray.50" pt={{ base: "10vh", md: "13vh" }}>
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align={{ base: "flex-start", md: "center" }}
        mb={8}
      >
        <Box>
          <Heading size="lg" color="gray.800" mb={2}>
            Store Level Report
          </Heading>
          <Text color="gray.500">
            Track assortments and stock health across every location
          </Text>
        </Box>

        <DateRangeFilter
          fromDate={fromDate}
          toDate={toDate}
          onFromDateChange={handleFromDateChange}
          onToDateChange={handleToDateChange}
        />
      </Flex>
      <SoftDrinkDp
        fromDate={fromDate}
        toDate={toDate} />
    </Box>
  );
}

export default StoreReport;

